

import Joi from 'joi';
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./Participant.Validator.js"

class ParticipantAPI {


/*
undefinedPOST http://localhost:3000/participants/create
Content-Type: application/json
Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

{
    "name" : "Nhà Thầu XD ABC",
    "participantType":"contractor",
    "participantId":"214500795244",
    "projectId":"522911722487",
    "role":"TONG_THAU",
    "contacts":[
    {"name":"Nguyen Van A","avatar":"link avatar","email":"nguyenvana@gmail.com","phone":"0921412421"}
    ]
}


*/    


  create = async (data) => {
    const validator = Validator.VALIDATION_PARTICIPANTS_CREATE;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/participants/create", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*

  POST http://localhost:3000/participants/list
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiI5OTgzNDM2NDA3ODMiLCJjcmVhdGVkQXQiOjE1MjE1OTE1Nzc5MzF9.NXhGQulhldhAxJTswJSJ_GTpokgxjLFZLU2Bmk-XeJw

  {
      "projectId":"522911722487"
  }

  */
  list = async (projectId) => {
    const validator = false; // change this to real variable
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/participants/list", { projectId });
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }

/*




*/
  delete = async (data) => {
    const validator = Validator.VALIDATION_PARTICIPANTS_DELETE;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message };
      }
    }
    let result = await Request.post(HOST + "/participants/delete", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

}
export default new ParticipantAPI();



// WEBPACK FOOTER //
// ./src/services/participant/Participant.API.js